export type LoginFormField = 'email' | 'password'

export type LoginFormFieldErrors = Partial<Record<LoginFormField, string>>

export type LoginFormValues = {
  email: string
  password: string
}

export const hasLoginFormErrors = (errors: LoginFormFieldErrors): boolean =>
  Object.keys(errors).length > 0

export const validateLoginForm = (values: LoginFormValues): LoginFormFieldErrors => {
  const errors: LoginFormFieldErrors = {}

  if (!values.email.trim()) {
    errors.email = 'Введите логин или email'
  }
  if (!values.password) {
    errors.password = 'Введите пароль'
  }

  return errors
}
